<div class="bg-white min-h-screen">
    <!-- Hero Section -->
    <div class="bg-app-background-20 py-16 border-b border-gray-200">
        <div class="max-w-4xl mx-auto px-6">
            <h1 class="text-4xl font-fraunce text-app-primary-20 mb-4">Häufige Fragen</h1>
            <p class="text-app-secondary-10 text-xl">Hier finden Sie Antworten auf die wichtigsten Fragen zu Patriacura.</p>
        </div>
    </div>

    <!-- Content -->
    <div class="max-w-4xl mx-auto px-6 py-16">
        <div class="space-y-4">
            @for (faq of faqs; track $index) {
                <div class="border border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm transition-all hover:shadow-md">
                    <button
                        (click)="toggleFaq($index)"
                        class="w-full flex items-center justify-between p-6 text-left focus:outline-none"
                    >
                        <span class="text-lg font-medium text-app-primary-20">{{ faq.question }}</span>
                        <i
                            class="fa-solid fa-chevron-down text-app-primary-10 transition-transform duration-300"
                            [class.rotate-180]="faq.open"
                        ></i>
                    </button>

                    <div
                        class="overflow-hidden transition-all duration-300"
                        [style.max-height]="faq.open ? '500px' : '0'"
                    >
                        <div class="p-6 pt-0 text-app-secondary-10 border-t border-gray-50 bg-gray-50/30">
                            {{ faq.answer }}
                        </div>
                    </div>
                </div>
            }
        </div>

        <div class="mt-16 bg-app-background-20 p-8 rounded-2xl text-center">
            <h3 class="text-2xl font-fraunce text-app-primary-20 mb-2">Haben Sie weitere Fragen?</h3>
            <p class="text-app-secondary-10 mb-6">Unser Support-Team hilft Ihnen gerne weiter.</p>
            <a href="mailto:info@patriacura.de" class="btn primary-button inline-flex items-center gap-2">
                <i class="fa-solid fa-envelope"></i>
                Kontakt aufnehmen
            </a>
        </div>
    </div>
</div>
